module.exports = __webpack_public_path__ + "img/icon-left.64e67a0f.svg";